import { t } from "i18next"

export const options = () => [
  { label: t("Down Payment"), value: "downPayment" },
  { label: t("Instalment"), value: "installment" },
  { label: t("Balloon"), value: "balloon_payment" },
  { label: t("Possession"), value: "possession" },
]
